import { render, staticRenderFns } from "./LmPromocionApp.vue?vue&type=template&id=5e0b864a"
import script from "./LmPromocionApp.vue?vue&type=script&lang=js"
export * from "./LmPromocionApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports